import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";

const initialState = {
    list: {
        isLoading: true,
        packages: [],
        error: "",
        currentPage: 1,
        pageCount: 0,
        search: '',
        facilitiesList: [],
        selectedFacility: { value: null, label: '' },
        spoolSearch: "",
    },
}

const namespacers = {
    listRejected: createNamespacer("LIST_REJECTED"),
}

const listReducer = createReducer(initialState.list, {
    [namespacers.listRejected("SET_PACKAGES")]:(state, action) => {
        return {
            ...state,
            packages: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [namespacers.listRejected("SET_ACTIVE_FACILITITES")]: (state, action) => {
        return {
            ...state,
            facilitiesList: action.payload.facilities
        }
    },
    [namespacers.listRejected("SET_SELECTED_FACILITY")]: (state, action) => {
        return {
            ...state,
            selectedFacility: action.payload,
        }
    },
    [namespacers.listRejected("SET_CLEAR_SEARCH")]:(state, action) => {
        return {
            ...state,
            search: initialState.search,
        }
    },
    [namespacers.listRejected("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.listRejected("SET_PAGE")]:(state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [namespacers.listRejected("SET_ERROR")]:(state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.listRejected("SET_SEARCH_PACKAGES")]:(state, action) => {
        return {
            ...state,
            search: action.payload.value,
        }
    },
    [namespacers.listRejected("SET_SPOOL_SEARCH")]:(state, action) => {
        return {
            ...state,
            spoolSearch: action.payload.value,
        }
    },
});

const reducer = combineReducers({
    list: listReducer,
})

export default reducer;